'use es6';

import omit from '../utils/underscore/omit';
import { CARD_BACKGROUND } from './PageConstants';
import UIAbstractPageTemplate from './UIAbstractPageTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
function UIDashboardPage(props) {
  return /*#__PURE__*/_jsx(UIAbstractPageTemplate, Object.assign({}, props, {
    horizontalDivider: true,
    mainSectionBackgroundColor: CARD_BACKGROUND
  }));
}
UIDashboardPage.propTypes = omit(UIAbstractPageTemplate.propTypes, 'horizontalDivider', 'mainClassName', 'mainSectionBackgroundColor', 'sidebarStyle');
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIDashboardPage.defaultProps = omit(UIAbstractPageTemplate.defaultProps, 'horizontalDivider', 'mainSectionBackgroundColor');
UIDashboardPage.displayName = 'UIDashboardPage';
export default UIDashboardPage;